// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__kdwx4","section-1":"styles_section-1__bNZzJ","content":"styles_content__Bsd32","section-2":"styles_section-2__BKJyV"};